export enum PaymentType {
	PER_VEHICLE = 'PER_VEHICLE',
	PER_FLEET = 'PER_FLEET',
	PER_DRIVER = 'PER_DRIVER',
}
